import { ComponentProps } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0VersionHistory, Spinner } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface VersionsNavigationProps {
  currentVersionId: number | undefined
  versions: ComponentProps<typeof F0VersionHistory>['versions']
  activeVersionId: number | 'current'
  onCurrentVersionClick: () => void
  isLoading: boolean
}

export const VersionsNavigation = ({
  currentVersionId,
  versions,
  activeVersionId,
  onCurrentVersionClick,
  isLoading,
}: VersionsNavigationProps) => {
  return (
    <Box
      flexDirection="column"
      flexNoShrink
      gap="s16"
      height="full"
      style={{
        width: '320px',
      }}
    >
      {isLoading ? (
        <Box alignItems="center" justifyContent="center" flexGrow>
          <Spinner />
        </Box>
      ) : (
        <F0VersionHistory
          title={i18n.t('pages.page.history_modal.title')}
          currentVersion={
            currentVersionId
              ? {
                  title: i18n.t('pages.page.history_modal.current_version'),
                  onClick: onCurrentVersionClick,
                }
              : undefined
          }
          versions={versions}
          activeVersionId={activeVersionId.toString()}
        />
      )}
    </Box>
  )
}
